<template>
  <modal
    :show="show"
    size="md:max-w-xl"
    classes="z-100"
    @close="logOut"
  >
    <template #header>
      <div class="title">
        <h3>Your session is about to expire</h3>
      </div>
    </template>

    <template #default>
      <div class="content">
        <p class="mb-6 text-md">
          <span v-if="isRefreshingToken">Returning to Whycatcher</span>
          <span v-else>You will be automatically logged out in {{ timeout }} seconds</span>
        </p>
      </div>
    </template>

    <template #footer>
      <div class="modal-footer text-right mt-3 flex justify-between">
        <button
          class="btn btn-primary"
          @click="staySignedIn"
        >
          <span
            v-if="isRefreshingToken"
            class="spinner"
          />
          <span v-else>Stay logged in</span>
        </button>
        <button
          class="btn btn-danger-outline"
          type="submit"
          @click="logOut"
        >
          <span
            v-if="isLoggingOut"
            class="spinner"
          />
          <span v-else>Log out</span>
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "~/components/Modals/Modal";
import authConfig from "../../constants/authConfig";

export default {
  components: {
    Modal
  },
  props: {
    restartIdleTimer: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      show: false,
      isRefreshingToken: false,
      isLoggingOut: false,
      timeout: 0
    };
  },
  methods: {
    async staySignedIn () {
      this.isRefreshingToken = true;
      try {
        const token = await this.$api.getRefreshToken();
        this.$auth.setUserToken(token.data.meta.token);
      }catch (e) {
        console.log('Error getting refresh token', e);
      } finally {
        this.timeout = 0;
        this.restartIdleTimer();
        this.show = false;
      }
    },

    open() {
      this.show = true;
    },

    async logOut() {
      this.isLoggingOut = true;
      this.$store.commit('auth/SET_LOGGED_OUT');
      this.$logout();
      await this.$router.push('/redirector');
    },

    startTimer() {
        if(this.timeout > 0) {
          setTimeout(() => {
            this.timeout -= 1;
            this.startTimer();
          }, 1000);
        }
        if(this.timeout === 0 && !this.isRefreshingToken){
          this.$store.commit('auth/SET_LOGGED_OUT');
          this.$logout();
          this.$router.push('/redirector');
        }
    }
  },

  events: {
    openSessionExpiryModal() {
      this.isRefreshingToken = false;
      this.timeout = parseInt(authConfig.inactivityTimerWarningDuration);
      this.startTimer();
      this.open();
    }
  }
};
</script>
